(function () {
  const reportsElement = document.getElementById('reports');
  const reportKeys = Object.keys(window).filter((key) => key.startsWith('report-'));
  const reportObjects = reportKeys.map((key) => window[key]);
  reportObjects.forEach((item) => {
    const li = document.createElement('li');
    li.className = 'eg';
    li.innerHTML = `
        <p class="item-icon">
          <img src='${item.icon}' alt='${item.title}' width='46' height='46' loading='lazy' >
        </p>
        <h3 class="item-text">${item.title}</h3>
        <p class="item-number"><span>${item.supportAmount}</span>円</p>`;
    if (item.supportAchievements.length) {
      let achievementsListItems = '';
      item.supportAchievements.forEach((object) => {
        achievementsListItems += `
            <li>
              <time>${object.supportDate}</time>
              <p>
                <a href="${object.url}" target="_blank">${object.title}</a>
              </p>
            </li>`;
      });
      li.insertAdjacentHTML(
        'beforeend',
        `
          <div class="item-work"> <span class="btn black w140">支援実績をみる</span>
            <div>
              <ul>
                ${achievementsListItems}
              </ul>
            </div>
          </div>`,
      );
    }
    reportsElement.appendChild(li);
  });

  $('.item-work .btn').click(function () {
    if ($(this).hasClass('opened')) {
      $(this).removeClass('opened').text('支援実績をみる').next().slideUp();
    } else {
      $(this).addClass('opened').text('閉じる').next().slideDown();
    }
  });
  $('.report-list .item-icon').matchHeight();
  $('.report-list .item-text').matchHeight();
  $('.report-list .item-number').matchHeight();
})();
